import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=18efdba2&"
import script from "./HistoryTab.vue?vue&type=script&lang=ts&"
export * from "./HistoryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection})
